export const SET_LOCKDOWNS = 'SET_LOCKDOWNS';
